import { motion, useScroll, useSpring } from "framer-motion";

/** Thin gold line at the top showing scroll progress. */
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[2px] bg-[#E7C583] origin-left z-[60]"
      style={{ scaleX }}
      data-testid="scroll-progress"
    />
  );
};

export default ScrollProgress;
